import { baseTheme } from 'styles/utils';
import { css } from '@linaria/core';
export const closeButton = "omponents__Dialog__dialogComponents_styles_ts-closeButton-c1t99yc0";
export const goBackButton = "omponents__Dialog__dialogComponents_styles_ts-goBackButton-g4zta25";
export const dialogHeading = "omponents__Dialog__dialogComponents_styles_ts-dialogHeading-d1icyx81";

require("./dialogComponents.styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./dialogComponents.styles.ts");